import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-exam-head',
  templateUrl: './exam-head.component.html',
  styleUrls: ['./exam-head.component.scss']
})
export class ExamHeadComponent implements OnInit {
  ExamHeadForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  examHeadList: any;
  list;
  ExamHeadSearchForm;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  isreaddelete: boolean;
  deleteButton: boolean;
  isDeleteReadonly: boolean;
  courselist: any;
  filteredListCourse: any;
  filteredListMarks: any;
  markslist: any;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner:NgxSpinnerService,) { this.APIService = environment.serviceUrl; }
  ngOnInit(): void {
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.list = false;
    this.ExamHeadForm = this.fb.group({
      EhMarkList: new FormControl('',[Validators.required]),
      EhType: new FormControl('',[Validators.required]),
      EhCode: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EhDefName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z0-9-&  \\s]*$')]),
      EhParent: new FormControl('',[Validators.pattern('^[a-zA-Z (./, -_)]*$')]),
      EhPrint: new FormControl('',[Validators.required]),
      EhSeq: new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),
      EhOrder: new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")])

    });
    this.ExamHeadSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });

    this.fetchMarkList();
   // //this.getExamHeadData();

    
  }

  keypress() {
    // this.umsService.searchExamSub(this.ExamHeadSearchForm
    //   .value).subscribe(res => {
    //     this.examHeadList = res.data;
    //   }, (ERROR: HttpErrorResponse) => {
    //     this.examHeadList = [];
    //   });
  }

  download() {
    let wwe = ['EhMarkList', 'EhType', 'EhCode', 'EhDefName', 'EhParent', 'EhPrint', 'EhSeq', 'EhOrder']
    this.umsService.downloadFile(this.examHeadList, 'jsontocsv', wwe);
  }

  getExamHeadData(val) {
    const payload = {};
    payload['EhMarkList'] = val;
    this.umsService.getExamHead(payload).subscribe(res => {
        this.examHeadList = res.data;
    });
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      //this.getExamHeadData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  submit() {
    if (this.ExamHeadForm.invalid) {
      this.ExamHeadForm.get('EhMarkList').markAsTouched();
      this.ExamHeadForm.get('EhType').markAsTouched();
      this.ExamHeadForm.get('EhCode').markAsTouched();
      this.ExamHeadForm.get('EhDefName').markAsTouched();
      this.ExamHeadForm.get('EhParent').markAsTouched();
      this.ExamHeadForm.get('EhPrint').markAsTouched();
      this.ExamHeadForm.get('EhSeq').markAsTouched();
      this.ExamHeadForm.get('EhOrder').markAsTouched();
      return;
    } else {
      if(this.ExamHeadForm.value['EhParent']==null ){
        this.PValid();
      }
      else{
        this.createExamHead();
      }
      //this.getExamHeadData();
    }
  }

  createExamHead() {
    this.spinner.show();
    this.submitpayload = this.ExamHeadForm.value;
    this.umsService.addExamHead(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  prepopulationForDelete(id) {
    this.editButton = false;
        this.submitButton = false;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.ExamHeadForm = this.fb.group({
          EhMarkList: new FormControl(id.EhMarkList),
          EhType: new FormControl(id.EhType),
          EhCode: new FormControl(id.EhCode),
          EhDefName: new FormControl(id.EhDefName),
          EhParent: new FormControl(id.EhParents),
          EhPrint: new FormControl(id.EhPrint),
          EhSeq: new FormControl(id.EhSeq),
          EhOrder: new FormControl(id.EhOrder)
        });
    // const payload = {};
    // payload['EhMarkList'] = 'Med';
    // this.umsService.getExamHead(payload).subscribe((res) => {
    //   const data = res.data[0];
    //   if (res.status) {
        
    //   } else {
    //     let data = {}
    //     // tslint:disable-next-line:no-string-literal
    //     data['message'] = res.message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-box-open'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   }
    // });
  }

  openConformationModalBox() {
    const data = {};
    // tslint:disable-next-line:no-string-literal
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    // tslint:disable-next-line:no-string-literal
    data['title'] = 'Alert';
    // tslint:disable-next-line:no-string-literal
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamHeadForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EhMarkList: id.EhMarkList,
        EhType: id.EhType,
        EhCode: id.EhCode,
        EhDefName: id.EhDefName,
        EhParent: id.EhParent,
        EhPrint: id.EhPrint,
        EhSeq: id.EhSeq,
        EhOrder: id.EhOrder

      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-head', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.ExamHeadForm.reset();
      // this.ExamHeadForm = this.fb.group({
      //   EhMarkList: new FormControl('',[Validators.required]),
      //   EhType: new FormControl('',[Validators.required]),
      //   EhCode: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      //   EhDefName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z0-9-& \\s]*$')]),
      //   EhParent: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z]*$')]),
      //   EhPrint: new FormControl('',[Validators.required]),
      //   EhSeq: new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),
      //   EhOrder: new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")])
      // });
    } else {
      this.list = true;
    }

  }

  fetchMarkList() {
    const payload = {};
    this.umsService.getMarkList(payload).subscribe(res => {
      if (res.status) {
        this.markslist = res.data;
        this.filteredListMarks = this.markslist.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });

  }

  getList(id){
    this.getExamHeadData(id);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  back() {
     
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.isread = false;
      //this.getExamHeadData();
    } else {
      this.list = true;
    }
  }

  PValid(){
    if(this.ExamHeadForm.value['EhType'] == 'P' && (this.ExamHeadForm.value['EhParent'] == null || this.ExamHeadForm.value['EhParent'] == '' )){
      let data = {}
        data['message'] = 'Order Required'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    else if(this.ExamHeadForm.value['EhType'] == 'I' && (this.ExamHeadForm.value['EhParent'] == null || this.ExamHeadForm.value['EhParent'] == '' )){
      let data = {}
        data['message'] = 'Parent required for InPart'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    } 
    else{ 
    }
  }
  

  

}
